<div class="monthly-downgrade-container">
  <div class="monthly-downgrade-content">
    <div class="monthly-downgrade-icon">
      🔄
    </div>
    <h2 class="monthly-downgrade-title">Cambiar a Plan Mensual</h2>
    <p class="monthly-downgrade-subtitle">Mantén la flexibilidad con pagos mensuales. Puedes cambiar tu plan cuando lo desees.</p>

    <div class="monthly-downgrade-benefits">
      <div class="benefit-item">
        <div class="benefit-icon">📅</div>
        <div class="benefit-text">
          <strong>Flexibilidad mensual</strong>
          <p>Paga mes a mes sin compromiso de largo plazo</p>
        </div>
      </div>
      <div class="benefit-item">
        <div class="benefit-icon">💳</div>
        <div class="benefit-text">
          <strong>Control de pagos</strong>
          <p>Gestiona tu presupuesto con pagos más frecuentes</p>
        </div>
      </div>
      <div class="benefit-item">
        <div class="benefit-icon">⚡</div>
        <div class="benefit-text">
          <strong>Cambio en próxima renovación</strong>
          <p>El cambio se aplicará al finalizar tu periodo actual</p>
        </div>
      </div>
    </div>

    <div class="plan-change-box" *ngIf="hasPreview">
      <convfact-plan-change-preview
        [planAlias]="data.planAlias"
        [period]="data.period"
        [renewalAmount]="data.renewalAmount"
        (stateChange)="onPreviewState($event)">
      </convfact-plan-change-preview>
    </div>

    <div class="monthly-downgrade-actions">
      <button type="button" class="btn btn-primary" (click)="onAccept()" [disabled]="preview.loading">
        ✅ Cambiar a Plan Mensual
      </button>
      <button type="button" class="btn btn-secondary" (click)="onCancel()">
        No por ahora
      </button>
    </div>
  </div>
</div>
